import { render, staticRenderFns } from "./standardlist.vue?vue&type=template&id=60f16b53&scoped=true&"
import script from "./standardlist.vue?vue&type=script&lang=js&"
export * from "./standardlist.vue?vue&type=script&lang=js&"
import style0 from "./standardlist.vue?vue&type=style&index=0&id=60f16b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f16b53",
  null
  
)

export default component.exports